// extracted by mini-css-extract-plugin
module.exports = {"button":"styles__button___3l0wf","container":"styles__container___1Jl4v","text":"styles__text___1iWBD","icon":"styles__icon___fpVXO"};